<p-dialog
  [(visible)]="visible"
  [modal]="modal"
  [closable]="closable"
  [style]="{ width: '450px' }"
  [showHeader]="false"
  maskStyleClass="backdrop-blur-sm"
  (visibleChange)="onCloseDialog()"
  [ngClass]="containerClass">

  <div class="flex flex-col items-center gap-6 text-center p-6">

    <!-- Icono -->
    <div class="dialog-icon">
      <i [class]="iconClass" [ngStyle]="getIconStyle()"></i>
    </div>

    <!-- Título -->
    <div class="dialog-title">
      {{ title }}
    </div>

    <!-- Mensaje -->
    <div class="dialog-message">
      @for (line of messageLines; track line) {
        <div class="mb-1 last:mb-0">{{ line }}</div>
      }
    </div>

    <!-- Botón -->
    <div class="dialog-button">
      <p-button
        [label]="buttonText"
        (onClick)="onConfirm()"
        styleClass="w-full">
      </p-button>
    </div>

  </div>
</p-dialog>